import PastPerformancePage from "./past-performance.page"

export default PastPerformancePage;
